module.exports = __webpack_public_path__ + "img/vtex-logo.2deeff8e.png";